import { useCallback } from 'react';

import { getServerTime } from '@interlayer/js/app/hooks/useServerTime/server';

let serverTimeDiff = 0;

export const useSaveServerTime = async () => {
    const localTimeDate = new Date();
    let serverTimeObj;

    try {
        serverTimeObj = await getServerTime();
    } catch {
        // Fallback to local time if server time fetch fails
        serverTimeObj = { timestamp: Math.floor(localTimeDate.getTime() / 1000) };
    }

    const serverTimestamp = serverTimeObj?.timestamp * 1000;
    const serverTimeDate = new Date(serverTimestamp);

    serverTimeDiff = localTimeDate.getTime() - serverTimeDate.getTime();

    return serverTimeDiff;
};

export const useGetServerTime = (timezoneOffsetParameter = 0) => {
    return useCallback((browserDate = new Date()) => {
        return new Date(browserDate.getTime() - serverTimeDiff + timezoneOffsetParameter * 1000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timezoneOffsetParameter]);
};
